import type { Platform } from '@/utils/get-platform'

export const PLATFORM_FLOW_NAME = {
  gallery: 'user-flow-landa',
  upptacka: 'user-flow-upptacka',
  web: 'user-flow-web',
} as const satisfies Record<Platform, string>

export const STEPS_PER_PLATFORM = {
  gallery: { LANDING_PAGE: 'landing-page', SCENE: 'scene', SUMMARY: 'summary' },
  upptacka: { LANDING_PAGE: 'landing-page', SCENE: 'scene' },
  web: { LANDING_PAGE: 'landing-page', SCENE: 'scene', SUMMARY: 'summary' },
} as const satisfies Record<Platform, Record<string, string>>

export function getUserFlowBasedOnPlatform<T extends Platform>(platform: T) {
  const flowName = PLATFORM_FLOW_NAME[platform]
  const availableSteps = STEPS_PER_PLATFORM[platform]

  return { availableSteps, flowName }
}
